// Client view of per-tenant settings. The trends opt-in now lives server-side (tenant.trends_opt_in);
// we cache it in-memory so the synchronous render gates (renderTrend) can read it without awaiting.
// Load it once on startup with loadTrendsSetting(); toggling writes through to /api/settings.
// New tenants are created with trends ON (db/accounts.ts) since the history can't be backfilled, but
// the manager can switch it off. The FALLBACK here stays OFF: if we can't read the real setting we
// render as though trends were disabled, so a fetch failure never implies consent we haven't confirmed.

import { getSettings, setTrendsOptIn } from './api.js';

let cachedOptIn = false;
let cachedAvailable = false; // server has TRENDS_ENABLED + pepper (i.e. persistence can actually happen)

/** Fetch the server-side opt-in once (call on app init). Falls back to OFF on any error. */
export async function loadTrendsSetting(): Promise<void> {
  try {
    const s = await getSettings();
    cachedOptIn = s.trends_opt_in;
    cachedAvailable = s.trends_available;
  } catch {
    cachedOptIn = false;
    cachedAvailable = false;
  }
}

export function isTrendsEnabled(): boolean {
  return cachedOptIn;
}

/** True when the backend can actually persist trends (feature flag + secret set). Display still works
 *  without it (single-call view), but no history accrues. */
export function isTrendsAvailable(): boolean {
  return cachedAvailable;
}

/** Optimistically flip the local cache and write through to the server (fire-and-forget). */
export function setTrendsEnabled(on: boolean): void {
  cachedOptIn = on;
  void setTrendsOptIn(on).catch(() => {});
}
